var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	19427: {
		fallback: () => (Promise.all([__webpack_require__.e(7141), __webpack_require__.e(1340)]).then(() => (() => (__webpack_require__(31340))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.8.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	85363: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(9427), __webpack_require__.e(2260), __webpack_require__.e(2076), __webpack_require__.e(9460)]).then(() => (() => (__webpack_require__(49460))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.22",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	16565: {
		fallback: () => (Promise.all([__webpack_require__.e(9427), __webpack_require__.e(1352)]).then(() => (() => (__webpack_require__(21352))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.22",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	72987: {
		fallback: () => (Promise.all([__webpack_require__.e(2615), __webpack_require__.e(4457)]).then(() => (() => (__webpack_require__(24457))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.10.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "firebase/auth",

	},
	57895: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(6565), __webpack_require__.e(4456)]).then(() => (() => (__webpack_require__(34456))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.22",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",

	},
	12368: {
		fallback: () => (Promise.all([__webpack_require__.e(1021), __webpack_require__.e(4967), __webpack_require__.e(436)]).then(() => (() => (__webpack_require__(80436))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.22",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	31021: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(9427), __webpack_require__.e(6613)]).then(() => (() => (__webpack_require__(16613))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.22",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	44803: {
		fallback: () => (__webpack_require__.e(9645).then(() => (() => (__webpack_require__(49645))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.11.7",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "dayjs",

	},
	83835: {
		fallback: () => (__webpack_require__.e(5098).then(() => (() => (__webpack_require__(25098))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.4.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "graphql-request",

	},
	97250: {
		fallback: () => (__webpack_require__.e(6227).then(() => (() => (__webpack_require__(46227))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.17.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "lodash",

	},
	12601: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(6565), __webpack_require__.e(2368), __webpack_require__.e(7415)]).then(() => (() => (__webpack_require__(17415))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.22",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	},
	99460: {
		fallback: () => (Promise.all([__webpack_require__.e(6127), __webpack_require__.e(2987), __webpack_require__.e(7895), __webpack_require__.e(4939), __webpack_require__.e(5704), __webpack_require__.e(2859)]).then(() => (() => (__webpack_require__(62859))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@core-hr/utility/angular",

	},
	42167: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(8148)]).then(() => (() => (__webpack_require__(8148))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng2-charts",

	},
	48361: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(2368), __webpack_require__.e(1021), __webpack_require__.e(2167), __webpack_require__.e(7424)]).then(() => (() => (__webpack_require__(77424))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.5.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@pathos/pathoslogos-ui",

	},
	76136: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(6565), __webpack_require__.e(6127), __webpack_require__.e(2987), __webpack_require__.e(7895), __webpack_require__.e(4939), __webpack_require__.e(8361), __webpack_require__.e(925)]).then(() => (() => (__webpack_require__(80925))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@core-hr/shared",

	},
	40995: {
		fallback: () => (Promise.all([__webpack_require__.e(4967), __webpack_require__.e(829), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(43835))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.22",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser/animations",

	},
	73948: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(6127), __webpack_require__.e(5704), __webpack_require__.e(8400)]).then(() => (() => (__webpack_require__(38400))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@core-hr/com/sdk",

	},
	73190: {
		fallback: () => (__webpack_require__.e(4518).then(() => (() => (__webpack_require__(24518))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.320.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@newrelic/browser-agent/features/logging",

	},
	75898: {
		fallback: () => (Promise.all([__webpack_require__.e(4518), __webpack_require__.e(2076), __webpack_require__.e(7149)]).then(() => (() => (__webpack_require__(47149))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.320.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@newrelic/browser-agent/loaders/browser-agent",

	},
	77399: {
		fallback: () => (Promise.all([__webpack_require__.e(7141), __webpack_require__.e(3620)]).then(() => (() => (__webpack_require__(23620))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.8.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",

	},
	50003: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(8513))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.22",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",

	},
	57191: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(36699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.22",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",

	},
	829: {
		fallback: () => (__webpack_require__.e(6596).then(() => (() => (__webpack_require__(26596))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.22",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations/browser",

	},
	46127: {
		fallback: () => (Promise.all([__webpack_require__.e(2615), __webpack_require__.e(6311)]).then(() => (() => (__webpack_require__(36311))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.10.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "firebase/firestore",

	},
	15704: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(12484))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxfire/firestore",

	},
	44539: {
		fallback: () => (Promise.all([__webpack_require__.e(2615), __webpack_require__.e(6725)]).then(() => (() => (__webpack_require__(36725))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.10.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "firebase/app",

	},
	52867: {
		fallback: () => (Promise.all([__webpack_require__.e(2615), __webpack_require__.e(987)]).then(() => (() => (__webpack_require__(60987))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.10.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "firebase/functions",

	},
	34867: {
		fallback: () => (Promise.all([__webpack_require__.e(2615), __webpack_require__.e(4713)]).then(() => (() => (__webpack_require__(94713))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.10.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "firebase/remote-config",

	},
	82455: {
		fallback: () => (__webpack_require__.e(8317).then(() => (() => (__webpack_require__(8317))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "encoding-japanese",

	},
	22087: {
		fallback: () => (__webpack_require__.e(5841).then(() => (() => (__webpack_require__(85841))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.0.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "file-saver",

	},
	29574: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(50659))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxfire/auth",

	},
	12593: {
		fallback: () => (Promise.all([__webpack_require__.e(2615), __webpack_require__.e(8125)]).then(() => (() => (__webpack_require__(60506))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.10.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "firebase/app-check",

	},
	12075: {
		fallback: () => (Promise.all([__webpack_require__.e(2615), __webpack_require__.e(639)]).then(() => (() => (__webpack_require__(40639))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.10.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "firebase/storage",

	},
	81051: {
		fallback: () => (Promise.all([__webpack_require__.e(2260), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(49074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.22",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"829": [
		829
	],
	"925": [
		82455,
		22087,
		29574
	],
	"1021": [
		31021
	],
	"2167": [
		42167
	],
	"2260": [
		50003,
		57191
	],
	"2368": [
		12368
	],
	"2601": [
		12601
	],
	"2859": [
		12593,
		12075
	],
	"2987": [
		72987
	],
	"3575": [
		44803,
		83835,
		97250
	],
	"4939": [
		44539,
		52867,
		34867
	],
	"5363": [
		85363
	],
	"5704": [
		15704
	],
	"6127": [
		46127
	],
	"6136": [
		76136
	],
	"6565": [
		16565
	],
	"7352": [
		40995,
		73948,
		73190,
		75898
	],
	"7399": [
		77399
	],
	"7424": [
		81051
	],
	"7895": [
		57895
	],
	"8361": [
		48361
	],
	"9180": [
		99460
	],
	"9427": [
		19427
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}